import React from 'react'
import { Card, Spin, Typography, Button } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiUrl } from '../config/api'
import ProductCard from '../components/ProductCard.jsx'
import { LeftOutlined } from '@ant-design/icons'

function useQueryParam(name) {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search).get(name), [search, name])
}

export default function SearchResults() {
  const navigate = useNavigate()
  const nameAr = useQueryParam('nameAr') || ''

  const raw = localStorage.getItem('deliveryLocation')
  let deliveryId = null
  if (raw) {
    try {
      const obj = JSON.parse(raw)
      if (obj && typeof obj === 'object') {
        deliveryId = obj.id ?? null
      }
    } catch {/* ignore */}
  }

  const enabled = !!nameAr && !!deliveryId

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['searchItems', nameAr, deliveryId],
    enabled,
    queryFn: async () => {
      const url = apiUrl(`/api/shopitems/search?nameAr=${encodeURIComponent(nameAr)}&deliveryLocationId=${encodeURIComponent(deliveryId)}`)
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } })
      if (!res.ok) {
        throw new Error(`فشل في جلب نتائج البحث (${res.status})`)
      }
      return res.json()
    }
  })

  const items = Array.isArray(data) ? data : []

  return (
    <div style={{ display: 'grid', gap: 'clamp(12px, 3vw, 20px)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Typography.Title level={3} style={{ margin: 0 }}>نتائج البحث</Typography.Title>
          <Button onClick={() => navigate('/categories')}>اضغط للعودة</Button>
      </div>

      {!nameAr && (
        <Card>
          <Typography.Paragraph style={{ margin: 0 }}>
            اكتب كلمة للبحث في المربع أعلى الصفحة.
          </Typography.Paragraph>
        </Card>
      )}

      {enabled && isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
          <Spin />
        </div>
      )}

      {enabled && isError && (
        <Card>
          <Typography.Text type="danger" style={{ marginBottom: 12, display: 'block' }}>
            حدث خطأ أثناء جلب النتائج: {error?.message || 'خطأ غير معروف'}
          </Typography.Text>
          <Button onClick={() => refetch()}>إعادة المحاولة</Button>
        </Card>
      )}

      {enabled && !isLoading && !isError && items.length === 0 && (
        <Card>
          <Typography.Paragraph style={{ margin: 0 }}>
            لا توجد نتائج مطابقة لبحثك.
          </Typography.Paragraph>
        </Card>
      )}

      {enabled && !isLoading && !isError && items.length > 0 && (
        <div style={{
          display: 'grid',
          gap: 'clamp(12px, 3vw, 16px)',
          gridTemplateColumns: 'repeat(auto-fill, minmax(132px, 1fr))'
        }}>
          {items.map((priced, idx) => (
            <div key={priced?.id || idx} style={{ display: 'flex' }}>
              <ProductCard pricedItem={priced} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
